module.exports = __webpack_public_path__ + "static/img/9.8524503.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/result/9.png
// module id = 3oBr
// module chunks = 57